import React, { } from 'react';
import { Container, RowLogin } from './styles';
import { useTranslation } from 'react-i18next';

export default function Menu() {
  const { t } = useTranslation()

  return (
    <Container>
      <RowLogin>
        <h1 style={{ width: '100%', textAlign: 'center' }}>{t('noPage')}</h1>
      </RowLogin>
    </Container>
  );
}